import { Moderator } from '@live-webinar/broadcast';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/m/$linkCode'].update({
        staticData: { title: { page: 'Title.Moderator', forWebinar: true } },
        component: authGuard(Moderator)
    });
};
